<template>
  <div>
    <div class="icon_tab" v-if="this.$route.path !== '/scanCode'"
      :class="this.$route.path == '/Home/Survey' || this.$route.path == '/Home/Exhibition' || this.$route.path == '/Home/Live' ? 'float_active1' : ''"
      :style="isShow ? '' : 'right: -100%'">
      <!-- :style="clientWidth < 750 ? isShow ? '' : 'right: -100%' : ''" -->
      <!-- 有奖调研 -->
      <img v-if="clientWidth > 768 && this.$route.path !== '/Home/Survey' && this.$route.path !== '/Home/Personal' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_tab_01.png" alt=""
        @click="handleClick1"  v-ga="{ event: 'trk', ec: 'sidebar', ea: 'survey', el: 'survey' }" />
      <!-- 有奖调研移动端 -->
      <img v-if="clientWidth <= 768 && this.$route.path !== '/Home/Survey' && this.$route.path !== '/Home/Personal' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_tab_01_m.png" alt=""
        @click="handleClick1" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'survey', el: 'survey' }" />
      <!-- 立即报名 -->
      <img  v-if="clientWidth > 768 && !$store.state.islogin && this.$route.path !== '/Home/Personal' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_tab_02.png" alt=""
        @click="handleClick2" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'regis' }" />
      <!-- 立即报名移动端 -->
      <img v-if="clientWidth <= 768 && !$store.state.islogin && this.$route.path !== '/Home/Personal' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/common/icon_tab_02_m.png" alt=""
        @click="handleClick2" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'regis' }" />
      <!-- 在线咨询 -->
      <img v-if="clientWidth > 768 && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2023/common/icon_tab_03.png" alt=""
        @click="handleClick3"  v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'survey' }" />
      <!-- 在线咨询移动端 -->
      <img v-if="clientWidth <= 768 && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2023/common/icon_tab_03_m.png" alt=""
        @click="handleClick3" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'survey' }" />
      <!-- 分享 -->
      <img v-if="clientWidth > 768 && $store.state.islogin && this.$route.path !== '/Home/Live' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2023/common/icon_tab_04.png" alt="" 
        @click="handleClick4" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'share' }" />
      <!-- 分享移动端 -->
      <img v-if="clientWidth <= 768 && $store.state.islogin && this.$route.path !== '/Home/Live' && this.$route.path !== '/Register'"
        src="https://staticdn.ht-s.cn/se/ciif/2023/common/icon_tab_04_m.png" alt=""
        @click="handleClick4" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'share' }" />
      <!-- 返回首页 -->
      <img class="backIndex"  v-if="clientWidth > 768 && this.$route.path != '/Home/Index' && this.$route.path !== '/'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/login/tab_home.png" alt=""
        @click="goIndex" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'return', el: 'homepage' }" />
      <!-- 返回首页移动端 -->
      <img class="backIndex" v-if="clientWidth <= 768 && this.$route.path != '/Home/Index' && this.$route.path !== '/'"
        src="https://staticdn.ht-s.cn/se/ciif/2022/login/tab_home_m.png" alt=""
        @click="goIndex" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'return', el: 'homepage' }" />
    </div>
    <!-- 分享海报 -->
    <SharePoster
      :imgSrc="posterImg"
      :isShow="posterShow"
      @closePoster="closePoster"
    ></SharePoster>
  </div>
</template>

<script>
import { GetSharePoster, GetUserLogs } from "@/api";
import SharePoster from "@/components/sharePoster/index.vue";
export default {
  data() {
    return {
      posterImg: "",
      posterShow: false,
      isShow: true
    };
  },
  components: {
    SharePoster,
  },
  mounted() {
    this.isShow = true
  },
  methods: {
    // 有奖调研
    handleClick1() {
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 6);
      this.$router.push({
        name: "Survey",
        query: {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    // 立即报名
    handleClick2() {
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        name: "Register",
        query: {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    // 在线咨询
    handleClick3() {
      window.open(
        "https://wechat.schneider-electric.cn/frontend/formscrm/index?id=7969&se_sr=SEemssite&se_ct=CIIF&se_cm=China_All_CN__202209_ciif&from=SEemssite"
      );
    },
    // 分享
    handleClick4() {
      this.$store.state.load = true;
      GetSharePoster({
        openId: this.userInfo.OpenId,
        mobile: this.userInfo.Phone,
        mailBox: this.userInfo.Email,
        gongBoId: 8743,
        number: 7,
      }).then((res) => {
        if (res.code === "OK") {
          this.posterImg = res.message;
          this.posterShow = true;

          GetUserLogs({
            visitName: "分享",
            visitType: 5,
            url: window.location.href,
            track: this.$route.query.track ? this.$route.query.track : 7756,
          });
        } else {
          this.$toast(res.message);
        }
        this.$store.state.load = false;
      });
    },
    closePoster() {
      this.posterShow = false;
    },
    // 返回首页
    goIndex() {
      var params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 0);
      // const obj = {

      // }
      this.$router.push({
        path: "/Home/Index",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    scrollTop() {
      return this.$store.state.scrollTop
    }
  },
  watch: {
    scrollTop(current,old) {
      if(current - old > 0 && old !== 0) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>